import { API, API_POST } from "../../../Config";

export const handleAddChallenges = (payload) => {


  const f = new FormData();

  f.append("title", payload.title);
  f.append("c_type", payload.c_type);
  f.append("r_title", payload.r_title);
  f.append("parameter", payload.parameter);
  f.append("parameter_type", payload.parameter_type);
  f.append("description", payload.description);
  f.append("image", payload.image);
  f.append("icon", payload.icon);

  return API_POST(API.AddChallenges, f);
};

